import { useEffect, useState } from "react"
import { doc, onSnapshot } from "firebase/firestore"
import { db } from "@/lib/firebase"
import type { PortfolioItem } from "@/types/models"

export function useTattooDetail(tattooId: string | undefined) {
  const [tattoo, setTattoo] = useState<PortfolioItem | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (!tattooId) {
      setTattoo(null)
      setLoading(false)
      return
    }

    setLoading(true)
    
    // Use onSnapshot for real-time updates instead of getDoc
    const unsubscribe = onSnapshot(
      doc(db, "portfolioItems", tattooId),
      (tattooDoc) => {
        if (tattooDoc.exists()) {
          const data = tattooDoc.data()
          const tattooData: PortfolioItem = {
            id: tattooDoc.id,
            artistId: data.artistId as string,
            type: (data.type as PortfolioItem["type"]) ?? "image",
            storagePath: (data.storagePath as string) ?? "",
            imageUrl: data.imageUrl as string,
            compressedImageUrl: data.compressedImageUrl as string | undefined,
            width: (data.width as number) ?? 0,
            height: (data.height as number) ?? 0,
            styleTags: (data.styleTags as string[]) ?? [],
            caption: (data.caption as string) ?? "",
            createdAt: data.createdAt?.toDate?.() ?? new Date(),
            isFlash: false,
          }
          setTattoo(tattooData)
          setError(null)
        } else {
          setError(new Error("Tattoo not found"))
          setTattoo(null)
        }
        setLoading(false)
      },
      (err) => {
        console.error("[useTattooDetail] Error fetching tattoo:", err)
        setError(err)
        setLoading(false)
      }
    )

    return () => unsubscribe()
  }, [tattooId])

  return { tattoo, loading, error }
}

